import { AgreementFormStep2Component } from 'src/app/pages/agreements/components/agreement-form/steps/agreement-form-step2/agreement-form-step2.component';
import { NotificationBase } from './notification-base';

export class NotificationAgreement extends NotificationBase {
  process(): void {
    this.showAlert();
  }

  // Declined offer / terminated agreement shouldn't call this
  protected viewNotification(): void {
    if (this.item.type === 'update') {
      this.agreementsService
        .getAgreementById(this.item.id)
        .then((agreement) => {
          this.modalCtrl
            .create({
              component: AgreementFormStep2Component,
              componentProps: { agreement },
            })
            .then((modal) => {
              // https://github.com/ionic-team/ionic-framework/issues/26872
              modal.shadowRoot.querySelector('.modal-wrapper').removeAttribute('aria-modal');

              modal.present();
            });
        })
        .catch((error) => {
          console.error('Error trying to redirect SP to update agreement section', error);
          this.navCtrl.navigateForward('/tabs/manage-clients?tab=agreements');
        });
    } else {
      this.navCtrl.navigateForward(`agreement/view/${this.item.id}`);
    }
  }

  // Overridden method for alert button(s)
  protected buttons(): any {
    switch (this.item.status) {
      case 'offer_declined':
        return [{ text: 'OK', role: 'cancel' }];
      case 'terminated':
        return [{ text: 'OK', role: 'cancel' }];
      default:
        return [
          { text: 'Ignore', role: 'cancel' },
          { text: 'View', handler: () => this.viewNotification() },
        ];
    }
  }
}
